module.exports = __webpack_public_path__ + "static/img/0402_06.3d92585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_06.png
// module id = tHIs
// module chunks = 1